import { Toast } from "../bootstrap_runtime"

export function showMessageToast(title, message, file = null, delay = 8000) {
  const container = document.getElementById("toast-container")
  if (!container) return

  const element = document.createElement("div")
  element.className = "toast"
  element.setAttribute("role", "alert")
  element.setAttribute("aria-live", "assertive")
  element.setAttribute("aria-atomic", "true")
  element.innerHTML = `
    <div class="toast-header">
      <strong class="me-auto"></strong>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body"></div>
  `
  element.querySelector("strong").textContent = title
  const body = element.querySelector(".toast-body")
  body.textContent = message
  if (file) {
    const link = document.createElement("a")
    link.href = file.url
    link.target = "_blank"
    link.rel = "noopener noreferrer"
    link.className = "btn btn-sm btn-bd-light mt-2"
    link.textContent = file.name
    body.append(document.createElement("br"), link)
  }
  container.appendChild(element)
  const toast = new Toast(element, { delay })
  element.addEventListener("hidden.bs.toast", () => {
    toast.dispose()
    element.remove()
  }, { once: true })
  toast.show()
  return element
}
